export default __webpack_public_path__ + "static/media/homeIcon.00c8bba3.svg";